import React from "react";
import "./Navbar.scss";
import logo from "../../Assets/Icons/logo.svg";
import twitter from "../../Assets/Icons/twitter.svg";
import opensea from "../../Assets/Icons/opensea.svg";
import discord from "../../Assets/Icons/discord.svg";
import wallet from "../../Assets/Images/wallet.png";

const Navbar = ({ homeNav }) => {
  return (
    <div id="navbar">
      <nav className={homeNav}>
        <div className="container-fluid navbarWidth">
          <a href="/">
            <img className="navlogo" src={logo} alt="logo" />
          </a>
          <div class="linkSection">
            <a className="navLink" href="/#">
              Home
            </a>
            <a className="navLink" href="/#">
              Vision
            </a>
            <a className="navLink" href="/#">
              Roadmap
            </a>
            <a className="navLink" href="/#">
              Rarity
            </a>
            <a className="navLink" href="/#">
              Team
            </a>
            <a className="navLink" href="/#">
              FAQ
            </a>
          </div>
          <div className="sectionBtn">
            <a
              className="navBtn"
              target="_blank"
              rel="noreferrer"
              activeClassName={"current"}
              href="https://twitter.com/axelcreatures"
            >
              <img className="navItem" src={discord} alt="twitter" />
            </a>
            <a
              className="navBtn"
              target="_blank"
              rel="noreferrer"
              activeClassName={"current"}
              href="https://twitter.com/axelcreatures"
            >
              <img className="navItem" src={twitter} alt="twitter" />
            </a>
            <a
              className="navBtn"
              target="_blank"
              rel="noreferrer"
              activeClassName={"current"}
              href="/"
            >
              <img className="navItem" src={opensea} alt="opensea" />
            </a>
            <a href="/" className="navWalletBtn">
              <img className="navWallet" src={wallet} alt="wallet" />
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
